/* Flair cookie banner - GDPR/CCPA
   Extracted from layout/theme.liquid. The banner markup uses inline onclick
   handlers, so these functions must stay global. */

function flairEnableTracking(prefs) {
  prefs = prefs || { analytics: true, marketing: true };

  // Enable Shopify customer privacy tracking (retry briefly in case the
  // customer privacy API hasn't loaded yet on first paint)
  var cpAttempts = 0;
  (function applyCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: prefs.analytics,
          marketing: prefs.marketing,
          preferences: true,
        },
        function () {}
      );
    } else if (cpAttempts++ < 20) {
      setTimeout(applyCustomerPrivacy, 500);
    }
  })();

  window.flairCookieConsent = prefs;
  window.flairTrackingAllowed = prefs.analytics || prefs.marketing;

  document.dispatchEvent(new CustomEvent('flairConsentGranted', { detail: prefs }));
}

function flairDisableTracking() {
  if (window.Shopify && window.Shopify.customerPrivacy) {
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: false,
        marketing: false,
        preferences: true,
      },
      function () {}
    );
  }

  window.flairCookieConsent = { essential: true, analytics: false, marketing: false };
  window.flairTrackingAllowed = false;

  // Clear existing tracking cookies
  var trackingPrefixes = ['_ga', '_gid', '_fb', '_fbp', '_fbc', '_gcl', '_pin', '_tt'];
  document.cookie.split(';').forEach(function (c) {
    var name = c.split('=')[0].trim();
    for (var i = 0; i < trackingPrefixes.length; i++) {
      if (name.startsWith(trackingPrefixes[i])) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        document.cookie =
          name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname;
        document.cookie =
          name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.' + window.location.hostname;
        break;
      }
    }
  });
}

function flairCookieHide() {
  var banner = document.getElementById('flair-cookie-banner');
  banner.classList.remove('is-visible');
  document.body.style.overflow = '';
  document.getElementById('flair-cookie-main').style.display = 'flex';
  document.getElementById('flair-cookie-settings').style.display = 'none';
}

function flairCookieShowSettings() {
  document.getElementById('flair-cookie-main').style.display = 'none';
  document.getElementById('flair-cookie-settings').style.display = 'flex';
}

function flairCookieShowMain() {
  document.getElementById('flair-cookie-main').style.display = 'flex';
  document.getElementById('flair-cookie-settings').style.display = 'none';
}

function flairCookieAcceptAll() {
  var prefs = { essential: true, analytics: true, marketing: true };
  localStorage.setItem('flair_cookie_consent', JSON.stringify(prefs));
  flairCookieHide();
  flairEnableTracking(prefs);
}

function flairCookieRejectAll() {
  var prefs = { essential: true, analytics: false, marketing: false };
  localStorage.setItem('flair_cookie_consent', JSON.stringify(prefs));
  flairCookieHide();
  flairDisableTracking();
}

function flairCookieSavePreferences() {
  var analytics = document.getElementById('flair-cookie-analytics').checked;
  var marketing = document.getElementById('flair-cookie-marketing').checked;
  var prefs = { essential: true, analytics: analytics, marketing: marketing };
  localStorage.setItem('flair_cookie_consent', JSON.stringify(prefs));
  flairCookieHide();
  if (analytics || marketing) {
    flairEnableTracking(prefs);
  } else {
    flairDisableTracking();
  }
}

// Helper: check consent status
window.flairCanTrack = function (type) {
  var consent = localStorage.getItem('flair_cookie_consent');
  if (!consent) return false;
  var prefs = JSON.parse(consent);
  if (type === 'analytics') return prefs.analytics;
  if (type === 'marketing') return prefs.marketing;
  return prefs.analytics || prefs.marketing;
};

// Helper: get all consent preferences
window.flairGetConsent = function () {
  var consent = localStorage.getItem('flair_cookie_consent');
  return consent ? JSON.parse(consent) : null;
};

(function () {
  var banner = document.getElementById('flair-cookie-banner');
  if (!banner) return;
  var backdrop = banner.querySelector('.flair-cookie-backdrop');
  var consent = localStorage.getItem('flair_cookie_consent');

  if (!consent) {
    // Opt-out model: no saved preference means tracking defaults ON so
    // marketing pixels (GA4, Meta, etc.) fire straight away. Nothing is
    // stored yet - an explicit choice in the banner overrides this.
    flairEnableTracking({ essential: true, analytics: true, marketing: true });
    setTimeout(function () {
      banner.classList.add('is-visible');
      if (window.innerWidth <= 600) {
        document.body.style.overflow = 'hidden';
      }
    }, 1000);
  } else {
    var prefs = JSON.parse(consent);
    if (prefs.analytics || prefs.marketing) {
      flairEnableTracking(prefs);
    }
  }

  // Close on backdrop click (mobile) - dismissing without choosing keeps
  // the default (tracking on) under the opt-out model
  if (backdrop) {
    backdrop.addEventListener('click', function () {
      flairCookieAcceptAll();
    });
  }
})();
